import { Module } from 'lib/vendor/terrific/Module';
import { Hook, Sandbox } from 'lib/vendor/terrific/Sandbox';

/**
 * Tc.Module.PexArticleDetail
 */
export default class PexArticleDetail extends Module {


	private readonly serviceUrl : string;
	private $button : JQuery;


	constructor($ctx : JQuery, sandbox : Sandbox, id : number, modName : string) {

		super($ctx, sandbox, id, modName);
		this.$button = $ctx.find('.agreeButton');
		this.serviceUrl = this.$button.data('ajax-url');
	}

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @param  {Hook} callback Callback function
	 * @return void
	 */
	public on(callback : Hook) {
		this.log.debug('starting');
		this.$button.on('click', this.sendResult.bind(this));

		callback();
	}

	private sendResult() {
		this.$button.addClass('disabled');
		$.post({
			async: false,
			data: {},
			dataType: 'json',
			success: this.onResult.bind(this),
			url: this.serviceUrl,
		});
	}

	private onResult() {
		this.$button.addClass('button--confirm');
		this.$button.removeClass('button--primary');
		const text = this.$button.text();
		this.$button.html(`<i class="icon-011-check-mark icon"></i> ${text}`);
		this.log.debug('Response success');
	}


}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/pex/Tc.Module.PexArticleDetail.ts